import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from './FooterComponent.module.css';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaGoogle, FaTwitter, FaXing } from 'react-icons/fa';
import img from "../../Images/png.png";
import footerlogo from '../../Images/footerlogo.png';


gsap.registerPlugin(ScrollTrigger);

const FooterComponent = ({ scrollToAbout, scrollToSubscriptions, scrollToTop }) => {
  const bottomImgRef = useRef(null);
  const bottomLogoRef = useRef(null);
  const footerRef = useRef(null);
  const navigator = useNavigate();

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Animate bottom logo with scale + rotation
      gsap.fromTo(
        bottomLogoRef.current,
        { transform: 'translateY(150%)' },
        {
          transform: 'translateY(0%)',
          duration: 2,
          delay: 1,
          ease: 'back.out(1.7)',
          scrollTrigger: {
            trigger: bottomLogoRef.current,
            start: 'top 100%',
            scrub: 2,
          },
        }
      );

      // Animate decorative bottom image with zoom-in and translateY
      gsap.fromTo(
        bottomImgRef.current,
        { scale: 0.8 },
        {
          scale: 2,
          delay: 1,
          opacity: 1,
          duration: 1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: bottomImgRef.current,
            start: 'top 100%',
            scrub: 1,
          },
        }
      );
    }, footerRef);

    return () => ctx.revert();
  }, []);

  return (
    <footer className={styles.footer} ref={footerRef}>
      <div className={styles.container}>
        {/* Left Section */}
        <div className={styles.section}>
          <p>ToxBox – Empowering smarter customer interactions with AI</p>
          <div className={styles.socialIcons}>
            <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/profile.php?id=61578963196930">
              <FaFacebookF />
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/provaantech">
              <FaLinkedinIn />
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/toxbox.ai/">
              <FaInstagram />
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://x.com/Provaantech">
              <FaXing />
            </a>
          </div>
        </div>

        {/* Products & Solutions */}
        <div className={styles.section}>
          <h3>Products & Solutions</h3>
          <ul>
            <li onClick={() => navigator('/ai-agents')}>AI Agents</li>
            <li onClick={() => navigator('/agent-builder')}>AI Agent Builder</li>
            <li onClick={() => navigator('/integrations')}>Integrations</li>
            <li onClick={() => navigator('/whatsapp')}>WhatsApp</li>
            <li onClick={() => navigator('/web')}>Web</li>
          </ul>
        </div>

        {/* Industries */}
        <div className={styles.section}>
          <h3>Industries</h3>
          <ul>
            <li onClick={() => navigator('/industries/real-estate')}>Real Estate</li>
            <li onClick={() => navigator('/industries/education')}>Education</li>
            <li onClick={() => navigator('/industries/healthcare')}>Healthcare</li>
            <li onClick={() => navigator('/industries/retail')}>Retail</li>
            <li onClick={() => navigator('/industries/travel')}>Travel & Hospitality</li>
          </ul>
        </div>

        {/* Resources & Company */}
        <div className={styles.section}>
          <h3>Resources & Company</h3>
          <ul>
            <li onClick={() => navigator('/resources/case-studies')}>Case Studies</li>
            <li onClick={() => navigator('/resources/blog')}>Tech Blog</li>
            <li onClick={() => navigator('/about')}>About Us</li>
            <li onClick={() => navigator('/careers')}>Careers</li>
            <li onClick={() => navigator('/contact')}>Contact Us</li>
          </ul>
        </div>
      </div>

      {/* Bottom Section */}
      <div className={styles.bottom}>
        <p>© 2025 ToxBox. All Rights Reserved.</p>
      </div>

      <div className={styles.bottomLogo} ref={bottomLogoRef}>
        <img src={footerlogo} alt="ToxBox Footer Logo" />
      </div>

      <div className={styles.bottomImg} ref={bottomImgRef}>
        <img src={img} alt="Decorative Bottom Image" />
      </div>
    </footer>
  );
};

export default FooterComponent;